import React from 'react'
import { Link } from 'react-router-dom'
// Image from public folder
const LUMO = "/assets/images/LUMO-Icon-Primary-Padded.png";

function Blogdtls({ blog, category, commentsCount }) {
    const formattedDate = new Date(blog.created_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    const capitalizeWord = (word) => {
        return String(word).charAt(0).toUpperCase() + String(word).slice(1);
    }

    return (
        <>
            <section className="blog_detail_section">
                <div className="container container-sm">
                    <div className="blog_head">
                        <div className="tags_info d-flex flex-row justify-content-between">
                            <div className="blog_info d-flex flex-column">
                                <div className="avtar mt-0 d-flex flex-row">
                                    <img src={blog.authorImage ? LUMO : blog.authorImage} alt="image" />
                                    <div className="text d-flex flex-column gap-0">
                                        <h3>{ blog.authorName === ("Undefined" || "undefined" || "") ? "LUMO Digital" : capitalizeWord(blog.authorName) }</h3>
                                        <span>Autor postare</span>
                                    </div>
                                </div>
                                <span className="tag">{category?.domain+" - "+category?.name  || 'Necategorizat'}</span>   
                            </div>

                            
                            <div className='blog_info d-flex flex-column align-items-center'>
                                <span className='blog_date'>{formattedDate}</span>
                                <div className='blog_stats d-flex flex-ror'>
                                    <span>❤️ {blog.likes}</span>    
                                    <span>💬 {commentsCount}</span>
                                </div>
                            </div>

                        </div>

                        
                    </div>
                    <div className="blog_body">
                        <h1 className='blog_title'>{blog.title}</h1>
                        <div className="img" data-aos="fade-in" data-aos-duration={1500}>
                            <img src={blog.thumbnail} alt="image" />
                        </div>
                        <h2>{blog.subtitle}</h2>
                        <div dangerouslySetInnerHTML={{ __html: blog.content?.text || '' }} />
                        <ul className="social_media">
                            <li>
                                <Link to="https://redirect.lumo.ro/social-instagram">
                                    <i className="icofont-instagram" />
                                </Link>
                            </li>
                            <li>
                                <Link to="https://redirect.lumo.ro/social-facebook">
                                    <i className="icofont-facebook" />
                                </Link>
                            </li>
                            <li>
                                <Link to="https://redirect.lumo.ro/social-whatsapp">
                                    <i className="icofont-whatsapp" />
                                </Link>
                            </li>
                            <li>
                                <Link to="https://redirect.lumo.ro/social-linkedin">
                                    <i className="icofont-linkedin" />
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Blogdtls